/**
 * Utilities to query focusable elements
 */

// https://github.com/gdkraus/accessible-modal-dialog/blob/master/modal-window.js#L38
const focusableElSelector =
	'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

export const findFocusable = (inElement: HTMLElement) => {
	return inElement.querySelectorAll<HTMLElement>(focusableElSelector);
};

export const findFirstFocusable = (
	inElement: HTMLElement,
): HTMLElement | undefined => {
	const focusable = findFocusable(inElement);
	return focusable[0];
};

export const findLastFocusable = (
	inElement: HTMLElement,
): HTMLElement | undefined => {
	const focusable = findFocusable(inElement);
	return focusable[focusable.length - 1];
};
